import styled from 'styled-components';

import { useComputedProperty } from 'dashboard/components/GridLayoutRender/computed-properties/useComputedProperty';
import { ComputedProperty } from 'dashboard/lib/case-layouts/computed-properties';
import Card from 'design-system/components/Card';

const IframeCard = styled(Card)`
  height: 100%;
  width: 100%;
`;

const IframeCardBody = styled(Card.Body)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export interface IframeProps {
  title: ComputedProperty;
  url: ComputedProperty;
  runCodeWithContext: (code: string) => Promise<unknown>;
}

const Iframe = ({ url, title, runCodeWithContext }: IframeProps) => {
  const [computedUrl] = useComputedProperty<string>(runCodeWithContext, url);
  const [computedTitle] = useComputedProperty<string>(runCodeWithContext, title);

  return (
    <IframeCard>
      <IframeCardBody>
        <Card.Title>{computedTitle}</Card.Title>
        <iframe
          css={`
            height: 100%;
            width: 100%;
          `}
          sandbox='allow-scripts allow-same-origin allow-forms'
          src={computedUrl ?? undefined}
        ></iframe>
      </IframeCardBody>
    </IframeCard>
  );
};

export default Iframe;
